export default "__VITE_ASSET__NhWv32t8__"